module.exports = __webpack_public_path__ + "img/frame-3.88398ba5.png";